import { useEffect, useState } from "react";
import API from "../../API/newIndex";
import GoogleLightHouse from "../../Assets/google-lighthouse.webp";
import Notification from "../Notification";
import LightHouseChart from "./LightHouseChart";
import ButtonComponent from "../FormInput/ButtonComponent";

const LightHouseData = () => {
  const [lightHouseData, setLightHouseData] = useState();
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [severity, setSeverity] = useState();
  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };
  const getDashBoardData = async () => {
    try {
      const apiCall = await API({
        url: `/admin/googleanalytics/getLighthouseReport`,
        method: "get",
      });
      const result = apiCall?.data;
      setLightHouseData(result?.data);
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };
  const generateReport = async () => {
    try {
      setIsLoading(true);
      const apiCall = await API({
        url: `/admin/googleanalytics/lighthouseReport`,
        method: "get",
        // params: { url: 'https://trimmo.app' },
      });
      console.log(apiCall?.data, "apiCall?.data");
      const result = apiCall?.data;
      setLightHouseData(result?.data);
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDashBoardData();
  }, []);

  const lighthouseConfig = [
    {
      key: "performance",
      label: "performance",
    },
    {
      key: "accessibility",
      label: "accessibility",
    },
    {
      key: "bestPractices",
      label: "bestPractices",
    },
    {
      key: "seo",
      label: "seo",
    },
  ];
  const getScoreColor = (score) => {
    if (score < 50) return "#e11515";
    if (score < 90) return "#ffa401";
    return "#23ad2c";
  };

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}

      <div className="flex flex-col jutify-center items-end gap-[10px] mt-[20px]">
        {lightHouseData && (
          <ButtonComponent
            onClick={generateReport}
            loading={isLoading}
            icon={
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"
                />
              </svg>
            }
          >
            Generate Lighthouse Report
          </ButtonComponent>
        )}

        <div className="apexcharts-datalabel-label pb-4 w-full">
          <div className="bg-[#2b4a9f] rounded-[10px] p-4 w-full">
            <div className="flex flex-col sm:flex-row gap-4 items-start relative">
              <div className="flex items-center justify-center">
                <img
                  src={GoogleLightHouse}
                  alt="Lighthouse"
                  className={`object-contain ${!lightHouseData ? "w-[170px] h-auto sm:w-[260px] lg:w-full" : "w-[150px]"}`}
                />
              </div>
              {lightHouseData ? (
                <div className="bg-white secondary-bg-color rounded-[8px] p-4 w-full text-center grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
                  {lighthouseConfig.map((item) => {
                    const value = Number(lightHouseData?.[item.key] ?? 0);

                    return (
                      <div
                        key={item.key}
                        className="flex flex-col items-center justify-center gap-2 min-h-[140px]"
                      >
                        <LightHouseChart
                          series={value}
                          label={item.label}
                          color={getScoreColor(value)}
                        />
                        <p className="mt-2 text-base font-medium capitalize">
                          {item.label}
                        </p>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <button
                    type="button"
                    onClick={() => {
                      generateReport();
                    }}
                    disabled={isLoading}
                    className={`pointer-events-auto flex items-center gap-2 px-4 py-2 rounded-md font-medium border transition-all ${isLoading ? "bg-gray-200 border-gray-300 text-gray-500 cursor-not-allowed" : "bg-white border-gray-400 text-gray-700 hover:bg-gray-100"}`}
                  >
                    {isLoading ? (
                      <svg
                        className="animate-spin h-4 w-4 text-gray-600"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"
                        ></path>
                      </svg>
                    ) : (
                      <>
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"
                          />
                        </svg>
                        Generate Lighthouse Report
                      </>
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LightHouseData;
